// -------------------
// Defaults
// -------------------

const defaults = {
    type: 'info',
    duration: 2000
};



// -------------------
// Toast class
// -------------------

class Toast {

    constructor (options) {
        Object.assign(this, defaults, options);
        this.timeout = null;
        this.id = Date.now();
    }

    wait (cb) {
        this.cb = () => cb(this);
        this.startedAt = Date.now();
        this.timeout = setTimeout(this.cb, this.duration);
    }

    pause () {
        clearTimeout(this.timeout);
    }

    resume () {
        const left = this.duration - (Date.now() - this.startedAt);
        if (left > 0) this.timeout = setTimeout(this.cb, left);
        else this.cb();
    }

}



// -------------------
// Exports
// -------------------

export default {

    namespaced: true,

    state: {
        queue: []
    },

    actions: {

        notify ({state}, {replace, ...options}) {
            if (replace) state.queue.unshift(new Toast(options));
            else state.queue.push(new Toast(options));
        },

        info ({dispatch}, message) {
            dispatch('notify', {message, type: 'info'});
        },

        warn ({dispatch}, message) {
            dispatch('notify', {message, type: 'warn'});
        },

        error ({dispatch}, message) {
            dispatch('notify', {message, type: 'error', duration: 5000});
        }


    }

}
